import { render, staticRenderFns } from "./BasicsProperty.vue?vue&type=template&id=4947ea60&scoped=true&"
import script from "./BasicsProperty.vue?vue&type=script&lang=js&"
export * from "./BasicsProperty.vue?vue&type=script&lang=js&"
import style0 from "./BasicsProperty.vue?vue&type=style&index=0&id=4947ea60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4947ea60",
  null
  
)

export default component.exports